import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initDeepLinks } from '../lib/deepLinks';

export function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => initDeepLinks(navigate), [navigate]);

  return null;
}
